import { doc, runTransaction, Timestamp } from 'firebase/firestore';
import { db } from '../firebase/config';
import { formatInvoiceNumber, formatOrderId } from './saleSerials';

export type SaleCounterKind = 'orders' | 'invoices';

function counterRef(tenantId: string, kind: SaleCounterKind) {
  return doc(db, `tenants/${tenantId}/counters/${kind}`);
}

async function allocateSequence(tenantId: string, kind: SaleCounterKind): Promise<number> {
  const ref = counterRef(tenantId, kind);

  return runTransaction(db, async (transaction) => {
    const snap = await transaction.get(ref);
    const lastSequence = snap.exists() ? Number(snap.data()?.lastSequence) || 0 : 0;
    const nextSequence = lastSequence + 1;

    transaction.set(
      ref,
      {
        lastSequence: nextSequence,
        updatedAt: Timestamp.now(),
      },
      { merge: true }
    );

    return nextSequence;
  });
}

export async function allocateOrderId(tenantId: string): Promise<string> {
  const sequence = await allocateSequence(tenantId, 'orders');
  return formatOrderId(sequence);
}

export async function allocateInvoiceNumber(
  tenantId: string
): Promise<{ invoiceNumber: string; invoiceSequence: number }> {
  const sequence = await allocateSequence(tenantId, 'invoices');
  return {
    invoiceNumber: formatInvoiceNumber(sequence),
    invoiceSequence: sequence,
  };
}
